<div class="options-table">
	<div class="filters">
		@if (widget()?.assetClass) {
			<app-asset-type [widget]="widget()" />
		}
	</div>

	<app-table
		[statesColumns]="statesColumns()"
		[settings]="{
			size: 'sm',
			spreadContent: 'space-between',
			rowBorder: true,
			emptyTextPath: 'positions.empty',
			defaultSort: widget()?.settings?.options?.activeSort ?? {
				prop: 'unrealized_plpc',
				type: 'desc',
			},
		}"
		[items]="positions()"
		[isLoading]="isLoadingPositions()"
		(onChangeSort)="changeSort($event)"
	>
		<app-table-column
			[settings]="{
				titlePath: 'positions.ticker',
				column: positionsOptionsColumnsEnum.option,
				canSort: true,
				propSort: 'symbol',
				minWidthPx: 205,
				maxWidthPx: 230,
			}"
		>
			<ng-template let-item="item">
				<div class="ticker-column">
					<span class="text">
						{{ item.option_ticker }}
					</span>
					<span class="text">
						{{ item.option_strike | price }}
					</span>
					<span
						class="text"
						highlight
						[isPositive]="item.option_type === optionTypeEnum.CALL"
						[isNegative]="item.option_type === optionTypeEnum.PUT"
					>
						{{ item.option_type | uppercase }}
					</span>
					<span class="text">
						{{ item.option_date | date: 'dd.MM.yyyy' }}
					</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.marketValue',
				column: positionsOptionsColumnsEnum.marketValue,
				canSort: true,
				propSort: 'market_value',
				minWidthPx: 80,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.market_value | price }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.quantity',
				column: positionsOptionsColumnsEnum.quantity,
				canSort: true,
				propSort: 'qty',
				minWidthPx: 80,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.qty | quantity }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.priceAveragePrice',
				column: positionsOptionsColumnsEnum.priceAveragePrice,
				canSort: true,
				propSort: 'current_price',
				minWidthPx: 100,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						class="text"
						>{{ item.current_price | price }}</span
					>
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="3"
						class="sub-text"
						>{{ item.avg_entry_price | price }}</span
					>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.share',
				column: positionsOptionsColumnsEnum.share,
				canSort: true,
				propSort: 'share',
				minWidthPx: 80,
				maxWidthPx: 80,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span class="text">{{ item.portfolio_allocation | percent: true }}</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.profitabilityPerDay',
				column: positionsOptionsColumnsEnum.profitabilityPerDay,
				canSort: true,
				propSort: 'unrealized_intraday_plpc',
				minWidthPx: 100,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						highlight
						[isPositive]="+item.unrealized_intraday_pl > 0"
						[isNegative]="+item.unrealized_intraday_pl < 0"
						[isNeutral]="!item.unrealized_intraday_pl"
						class="text"
					>
						{{ item.unrealized_intraday_pl | profit: 'dollar' }}
					</span>
					<span
						highlight
						[isPositive]="+item.unrealized_intraday_plpc > 0"
						[isNegative]="+item.unrealized_intraday_plpc < 0"
						[isNeutral]="!item.unrealized_intraday_plpc"
						class="sub-text"
					>
						{{ item.unrealized_intraday_plpc | profit: 'percent' }}
					</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'positions.profitability',
				column: positionsOptionsColumnsEnum.profitability,
				canSort: true,
				propSort: 'unrealized_plpc',
				minWidthPx: 100,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="column">
					<span
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						highlight
						[isPositive]="item.unrealized_pl > 0"
						[isNegative]="item.unrealized_pl < 0"
						[isNeutral]="!item.unrealized_pl"
						class="text"
					>
						{{ item.unrealized_pl | profit: 'dollar' }}
					</span>
					<span
						highlight
						[isPositive]="item.unrealized_plpc > 0"
						[isNegative]="item.unrealized_plpc < 0"
						[isNeutral]="!item.unrealized_plpc"
						class="sub-text"
					>
						{{ item.unrealized_plpc | profit: 'percent' }}
					</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-actions>
			<ng-template let-item="item">
				<app-positions-options-actions [option]="item" />
			</ng-template>
		</app-table-actions>

		<app-table-footer>
			<ng-template>
				<div class="footer">
					<div class="total">
						<span class="title">{{ 'positions.total' | translate }}:</span>
						<span
							class="value"
							[tuiSkeleton]="isLoadingPositions()"
							>{{ positions().length | quantity }}</span
						>
					</div>
				</div>
			</ng-template>
		</app-table-footer>
	</app-table>
</div>
